import ListItemText from '@material-ui/core/ListItemText'
import MenuItem from '@material-ui/core/MenuItem'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import Menu from '@material-ui/core/Menu'
import { withStyles } from '@material-ui/core/styles'
import MoreVert from '@material-ui/icons/MoreVert'
import { unwrapResult } from '@reduxjs/toolkit'
import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import Button from '../../../../components/CustomButtons/Button'
import SuperGeneralDeleteModal from '../../../Components/SuperGeneralDeleteModal'

import {
  DeleteEvidenceType, fetchEvidenceTypeStatesConfigs
} from '../../../../reduxToolkit/features/EvidenceType/EvidenceTypeSlice'

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))

const EvidenceTypeDown = (props) => {

  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [open, setOpen] = React.useState(false)
  const [openErrorModal, setOpenErrorModal] = React.useState(false)
  const [handledError, setHandledError] = React.useState('')
  const handleOpenEvidence = () => setOpenModalEvidence(true)
  const { t } = useTranslation()
  const [openModalEvidence, setOpenModalEvidence] = useState(false)
  const handleOpenErrorModal = () => {
    setOpenErrorModal(true)
  }
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false)
  }
  const handleCloseDeleteModal = () => {
    setOpen(false)
  }
  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    })
  }
  const handleDeleteItem = async (id) => {
    console.log('id : ', id)
    dispatch(DeleteEvidenceType(id))
      .then(unwrapResult)
      .then((originalPromiseResult) => {
        // handle result here
        openNotificationWithIcon('success', `Deleted`)

        console.log('originalPromiseResult', originalPromiseResult)
        dispatch(fetchEvidenceTypeStatesConfigs())
      })
      .catch((rejectedValueOrSerializedError) => {
        // handle error here
        console.log(
          'rejectedValueOrSerializedError',
          rejectedValueOrSerializedError,
        )
        setHandledError(rejectedValueOrSerializedError)
        handleOpenErrorModal()
      })
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleOpenDeleteModal = () => {
    setOpen(true)
  }
  return (
    <div>
      <Button
        aria-controls="customized-menu"
        variant="contained"
        color="primary"
        onClick={handleClick}
        justIcon
        round
        aria-haspopup="true"
      >
        <MoreVert />
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Link
          to={`/citrine/configuration/editEvidenceType/${props.el.id}`}
        >
          <MenuItem>{t('Edit')}</MenuItem>
        </Link>
        <MenuItem
          onClick={() => {
            handleOpenDeleteModal()
            handleClose()
          }}
        >
          <ListItemText primary="Delete" />{' '}
        </MenuItem>
      </StyledMenu>

      <SuperGeneralDeleteModal
        delete_Element={handleDeleteItem}
        Element_ID={props.el.id}
        open={open}
        handleClose={handleCloseDeleteModal}
      />
    </div>
  )
}

export default EvidenceTypeDown
